import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/Global-Services/common.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ExcelUploadService } from 'src/app/Global-Services/excel-upload.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-bulk-upload-access-matrix',
  standalone: false,
  templateUrl: './bulk-upload-access-matrix.component.html',
  styleUrl: './bulk-upload-access-matrix.component.css'
})
export class BulkUploadAccessMatrixComponent implements OnInit  {

  formData: any;

  AcccessMatrixRecordUpload = {
  AttachmentName: '',
  AttachmentData: null,
  AttachmentID: 0,
  AttachmentList: [],
  ExcelFilePath:"",
};

ErrorMessage = [];
isLoading : Boolean = false;
@ViewChild('fileInput') fileInput!: ElementRef;

  constructor(private _router: Router,
    private gservice: CommonService,
    public ExcelUpload: ExcelUploadService,
  ) { }


  ngOnInit()
  {

  }

  UploadAttachment(event: any)
  {
    this.isLoading = true;
    if (event.target.files.length > 0) {
      const fileList: FileList = event.target.files;
      const file: File = fileList[0];
      const maxLength = 1024 * 1024 * 5;
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      this.AcccessMatrixRecordUpload.AttachmentList.push({ 'AttachmentName': file.name, 'AttachmentID': 0, 'IsDeleted': false });
      this.AcccessMatrixRecordUpload.AttachmentName = file.name;

      if (fileExtension.toLowerCase() === 'xlsx') {
        this.formData = new FormData();
        if (event.target.files[0].size > maxLength) {
          alert('Filesize can not be more than 5 mb.');
          this.AcccessMatrixRecordUpload.AttachmentList = [];
          this.AcccessMatrixRecordUpload.AttachmentName = '';
          this.AcccessMatrixRecordUpload.AttachmentID = 0;
          this.clearFileInput();
          this.isLoading = false;
          return;
        }
        this.formData.append('Attachments', file, file.name);
        this.gservice.UploadAttachment(this.formData, 'FTEDetails/FTEUploadFile').subscribe(data => {
          if(data!=null )
        {
          this.AcccessMatrixRecordUpload.ExcelFilePath="";
            this.AcccessMatrixRecordUpload.ExcelFilePath=data;
        }
        this.isLoading = false;
        });
      } else {
        alert('Please upload xlsx file.');
        this.isLoading = false;
        this.formData = null;
        this.clearFileInput();
        this.AcccessMatrixRecordUpload.AttachmentList = [];
        this.AcccessMatrixRecordUpload.AttachmentName = '';
        this.AcccessMatrixRecordUpload.AttachmentID = 0;
      }
    }
  }


  DownloadFormat() {
    this.isLoading = true;
    let binaryData: Uint8Array = new Uint8Array();
    const templatename = "Upload format-Access Matrix-IN FTE Contract Extension.xlsx";
    this.gservice.DownloadAccessMatrixUploadFormat(templatename).subscribe((data: any) => {
      if (data != null) {
           binaryData = this.base64ToArrayBuffer(data.FileContent);
          const blob = new Blob([binaryData], { type: 'application/octet-stream' });
          const fileName = data.FileName;
          FileSaver(blob, fileName);
      }
          this.isLoading = false;
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
      this.gservice.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
      });
     this.gservice.RedirectToErrorPage(2);
    });
  }

  private base64ToArrayBuffer(base64: string): Uint8Array {
    const binaryString = window.atob(base64);
    const length = binaryString.length;
    const bytes = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  submit()
  {
    this.isLoading = false;
    this.ErrorMessage = [];
    if(this.AcccessMatrixRecordUpload.AttachmentList.length>0)
    {
      this.gservice.PostService({excelFilePath : this.AcccessMatrixRecordUpload.ExcelFilePath },'AccessMatrix/VerifyUploadedFile').subscribe((data: any) => {
        if(data!=null && data.length>0)
        {   for (var i = 0; i < data.length; i++) {
          this.ErrorMessage.push({ message : data[i] });
        }
      }
      if (this.ErrorMessage.length > 0) {
        this.clearFileInput();
        this.isLoading = false;
        return;
      }
      else{
        this.gservice.PostService(this.AcccessMatrixRecordUpload, 'AccessMatrix/SaveBulkAccessMatrixUpload').subscribe(data => {
          if(data.Table=="")
          {
            alert("Data Submitted Successfully!");
            this._router.navigate(['/INFTE/home']);
            this.isLoading = false;
          }
          else
          {
              this.ExcelUpload.exportAsExcelFile(data.Table, 'AccessMatrixErrorFile');
              this.isLoading = false;
          }

        },
          (err: HttpErrorResponse) => {
            this.isLoading = false;
            this.gservice.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
            });
            this.gservice.RedirectToErrorPage(2);
          });

      }
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gservice.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gservice.RedirectToErrorPage(2);
      });

  }
  }

   onExit()
  {
    let confirm = false;
    const message = 'Are You Sure Want to Exit.';
    confirm = window.confirm(message);

    if (confirm) {
      this._router.navigate(['/INFTE/home']);
    }
  }

  clearFileInput() {
    this.fileInput.nativeElement.value = '';
 }

}
